var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "date",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    top: 238,
    left: 596,
    width: 26.394,
    height: 26.385,
    viewBox: "0 0 26.394 26.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 26.394,
    height: 26.385,
    fill: "#959595"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6758",
    "data-name": "Path 6758",
    d: "M24.32,16.886q0-5.295,0-10.589a2.049,2.049,0,0,0-1.552-2.1,8.021,8.021,0,0,0-1.745-.074c-.129-.005-.1.084-.1.156,0,.266,0,.533,0,.8a1.033,1.033,0,1,1-2.06-.012c0-.267-.006-.532,0-.8,0-.111-.028-.146-.143-.145q-2.2.005-4.405,0c-.111,0-.148.029-.145.143q.012.438,0,.876a1.029,1.029,0,1,1-2.058-.01c-.006-.283-.007-.567,0-.85,0-.121-.029-.16-.156-.16q-2.164.006-4.328,0c-.121,0-.163.03-.159.156.009.284.007.567,0,.85a1.03,1.03,0,1,1-2.059-.008c0-.283,0-.566,0-.85,0-.062.029-.15-.087-.145a7.29,7.29,0,0,0-1.742.086,2.039,2.039,0,0,0-1.518,2c-.006.266,0,.532,0,.8q0,7.561,0,15.124a2.059,2.059,0,0,0,1.532,2.117,2.531,2.531,0,0,0,.714.078c5.916,0,11.833-.011,17.749.007a2.145,2.145,0,0,0,2.27-2.11,1.008,1.008,0,0,1,1.07-.987,1.032,1.032,0,0,1,.982,1.08,3.737,3.737,0,0,1-.085.766,4.116,4.116,0,0,1-4.1,3.3c-2.456.006-4.912,0-7.368,0q-5.306,0-10.613,0a4.123,4.123,0,0,1-3.995-2.8c-.091-.262-.148-.536-.221-.8V5.668A3.907,3.907,0,0,1,1.681,2.789a4.038,4.038,0,0,1,2.426-.8c.334-.006.669,0,1,0,.163,0,.235-.065.231-.23-.005-.2,0-.395,0-.592A2.022,2.022,0,0,1,5.35.912.984.984,0,0,1,6.234,0h.412a1,1,0,0,1,.9,1.086c.005.2,0,.394,0,.591.005.282.026.306.313.306,1.1,0,2.193,0,3.29,0,.206,0,.411-.005.617,0,.184.006.267-.07.263-.257,0-.231-.006-.463,0-.694a1.15,1.15,0,0,1,.381-.842A1,1,0,0,1,12.933,0h.412a1,1,0,0,1,.9,1.086c.005.2,0,.395,0,.591.005.282.027.306.313.306,1.062,0,2.125,0,3.187,0,.257,0,.514,0,.771,0,.184,0,.267-.07.263-.257q-.007-.321,0-.643A1,1,0,0,1,19.682,0h.412a1.146,1.146,0,0,1,.83,1.283c-.014.253-.116.6.043.737s.49.047.746.039a4.632,4.632,0,0,1,2.4.449,3.972,3.972,0,0,1,2.253,3.5c.057,1.449.016,2.9.017,4.354q0,3.311,0,6.621a1.1,1.1,0,0,1-.34.882.979.979,0,0,1-1.054.2,1,1,0,0,1-.662-.873,2.672,2.672,0,0,1-.007-.309",
    transform: "translate(0 0.001)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6759",
    "data-name": "Path 6759",
    d: "M75.586,72.668c-.342.259-.691.508-1.034.766a.532.532,0,0,0-.227.714c.127.4.263.8.391,1.195a.539.539,0,0,1-.146.673c-.212.161-.416.144-.7-.064-.341-.245-.679-.495-1.022-.738a.539.539,0,0,0-.75,0c-.35.248-.693.5-1.043.753-.274.2-.476.209-.684.055a.536.536,0,0,1-.151-.671c.12-.375.245-.748.368-1.122.141-.433.1-.57-.259-.837-.317-.235-.636-.467-.951-.7-.282-.211-.362-.419-.268-.681s.264-.36.611-.362c.206,0,.412,0,.618,0H70.9c.453,0,.553-.073.688-.494.121-.374.24-.75.364-1.123.1-.305.276-.453.526-.441a.537.537,0,0,1,.5.439q.195.611.4,1.22a.478.478,0,0,0,.548.4c.438,0,.876,0,1.314,0a.535.535,0,0,1,.6.383.542.542,0,0,1-.253.642",
    transform: "translate(-54.897 -55.307)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6760",
    "data-name": "Path 6760",
    d: "M28.432,48.752A1.029,1.029,0,1,1,27.4,47.727a1.034,1.034,0,0,1,1.033,1.025",
    transform: "translate(-20.963 -37.935)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6761",
    "data-name": "Path 6761",
    d: "M50.28,48.749a1.029,1.029,0,1,1-1.035-1.023,1.035,1.035,0,0,1,1.035,1.023",
    transform: "translate(-38.328 -37.934)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6762",
    "data-name": "Path 6762",
    d: "M72.128,48.744a1.029,1.029,0,1,1-1.04-1.018,1.034,1.034,0,0,1,1.04,1.018",
    transform: "translate(-55.693 -37.934)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6763",
    "data-name": "Path 6763",
    d: "M93.976,48.763a1.029,1.029,0,1,1-1.021-1.038,1.035,1.035,0,0,1,1.021,1.038",
    transform: "translate(-73.058 -37.934)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6764",
    "data-name": "Path 6764",
    d: "M28.432,70.6A1.029,1.029,0,1,1,27.4,69.577,1.034,1.034,0,0,1,28.432,70.6",
    transform: "translate(-20.963 -55.301)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6765",
    "data-name": "Path 6765",
    d: "M50.28,70.6a1.029,1.029,0,1,1-1.035-1.023A1.035,1.035,0,0,1,50.28,70.6",
    transform: "translate(-38.328 -55.301)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6766",
    "data-name": "Path 6766",
    d: "M28.432,92.454a1.029,1.029,0,1,1-1.03-1.028,1.034,1.034,0,0,1,1.03,1.028",
    transform: "translate(-20.963 -72.668)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6767",
    "data-name": "Path 6767",
    d: "M50.28,92.443a1.029,1.029,0,1,1-1.04-1.018,1.035,1.035,0,0,1,1.04,1.018",
    transform: "translate(-38.328 -72.667)",
    fill: "#959595"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.880e7da57406fc6f1f246cd9e5e5d967.svg";
export { ForwardRef as ReactComponent };